import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'

export const postBoxSlice = createSlice({
  name: 'postBox',
  initialState: {
    shareToTimeline: {},
  },
  reducers: {
    setPostBoxShareToTimeline: (
      state,
      actions: PayloadAction<{ type: 'group' | 'thread' }>
    ) => {
      state.shareToTimeline = actions.payload
    },
    clearPostBoxShareToTimeline: (state, _actions: PayloadAction) => {
      state.shareToTimeline = {}
    },
  },
})

export const selectPostBoxShareToTimeline = createSelector(
  (state: any) => state.postBox,
  (state) => state.shareToTimeline
)

export const { setPostBoxShareToTimeline, clearPostBoxShareToTimeline } =
  postBoxSlice.actions

export default postBoxSlice.reducer
